import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { getLang } from "../store/uiStore";
import "./Sidebar.css";

const menu = [
  {
    name: "dashboard",
    path: "/",
    roles: ["clinic", "clinic_inspector", "regional_inspector", "central", "admin"],
    icon: "dashboard",
  },
  {
    name: "clinics",
    path: "/clinics",
    roles: ["clinic_inspector", "regional_inspector", "central", "admin"],
    icon: "clinics",
  },
  {
    name: "passport",
    path: "/passport",
    roles: ["clinic", "clinic_inspector", "regional_inspector", "central", "admin"],
    icon: "passport",
  },
  {
    name: "incidents",
    path: "/incidents",
    roles: ["clinic", "clinic_inspector", "regional_inspector", "central", "admin"],
    icon: "incidents",
  },
  {
    name: "reports",
    path: "/reports",
    roles: ["clinic", "clinic_inspector", "regional_inspector", "central", "admin"],
    icon: "reports",
  },
  {
    name: "analytics",
    path: "/analytics",
    roles: ["regional_inspector", "central", "admin"],
    icon: "analytics",
  },
  {
    name: "admin",
    path: "/admin",
    roles: ["admin"],
    icon: "admin",
  },
];

const translations = {
  dashboard: { tj: "Панели асосӣ", ru: "Главная панель" },
  clinics: { tj: "Феҳристи муассисаҳо", ru: "Реестр учреждений" },
  passport: { tj: "Шиносномаи муассиса", ru: "Паспорт учреждения" },
  incidents: { tj: "Хабардиҳии аввалиндараҷа", ru: "Экстренные извещения" },
  reports: { tj: "Ҳисоботдиҳӣ", ru: "Отчётность" },
  analytics: { tj: "Таҳлил", ru: "Аналитика" },
  admin: { tj: "Маъмурият", ru: "Администрирование" },
};

function MenuIcon({ type }) {
  const common = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
  };

  switch (type) {
    case "clinics":
      return (
        <svg {...common}>
          <path d="M4 21V8.5L12 4l8 4.5V21" />
          <path d="M8 21v-5h8v5" />
          <path d="M9 11h6" />
          <path d="M12 8v6" />
        </svg>
      );
    case "passport":
      return (
        <svg {...common}>
          <rect x="5" y="3.5" width="14" height="17" rx="2" />
          <circle cx="12" cy="9" r="2.2" />
          <path d="M8.5 16c.8-1.6 2-2.4 3.5-2.4s2.7.8 3.5 2.4" />
        </svg>
      );
    case "incidents":
      return (
        <svg {...common}>
          <path d="M12 3 21 20H3L12 3Z" />
          <path d="M12 9v5" />
          <path d="M12 17h.01" />
        </svg>
      );
    case "reports":
      return (
        <svg {...common}>
          <path d="M6 3h9l3 3v15H6z" />
          <path d="M15 3v4h4" />
          <path d="M9 12h6M9 16h6" />
        </svg>
      );
    case "analytics":
      return (
        <svg {...common}>
          <path d="M4 19V5" />
          <path d="M4 19h16" />
          <path d="m7 15 4-4 3 2 5-6" />
        </svg>
      );
    case "admin":
      return (
        <svg {...common}>
          <path d="M12 3 20 6v5c0 5-3.2 8.1-8 10-4.8-1.9-8-5-8-10V6l8-3Z" />
          <path d="M9.5 12h5M12 9.5v5" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <rect x="4" y="4" width="6" height="6" rx="1" />
          <rect x="14" y="4" width="6" height="6" rx="1" />
          <rect x="4" y="14" width="6" height="6" rx="1" />
          <rect x="14" y="14" width="6" height="6" rx="1" />
        </svg>
      );
  }
}

export default function Sidebar() {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const role = user?.role;
  const lang = getLang();

  const filteredMenu = menu.filter((item) => item.roles.includes(role));

  const [collapsed, setCollapsed] = useState(
    localStorage.getItem("sidebarCollapsed") === "1"
  );

  const [mobileOpen, setMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    function handleResize() {
      const mobile = window.innerWidth <= 900;
      setIsMobile(mobile);

      if (!mobile) {
        setMobileOpen(false);
      }
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function toggleCollapse() {
    const next = !collapsed;
    setCollapsed(next);
    localStorage.setItem("sidebarCollapsed", next ? "1" : "0");
  }

  function toggleMobile() {
    setMobileOpen((prev) => !prev);
  }

  return (
    <>
      {isMobile && (
        <button
          type="button"
          className={`nizom-mobile-menu-button ${mobileOpen ? "open" : ""}`}
          onClick={toggleMobile}
          aria-label={mobileOpen ? "Закрыть меню" : "Открыть меню"}
          aria-expanded={mobileOpen}
        >
          <span />
          <span />
          <span />
        </button>
      )}

      {isMobile && mobileOpen && (
        <div
          className="nizom-sidebar-overlay"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      <aside
        className={[
          "nizom-sidebar",
          collapsed && !isMobile ? "collapsed" : "",
          isMobile ? "mobile" : "",
          isMobile && mobileOpen ? "mobile-open" : "",
        ].join(" ")}
      >
        <div className="nizom-sidebar-top">
          <div className="nizom-sidebar-section-label">
            {lang === "tj" ? "МЕНЮ" : "МЕНЮ"}
          </div>

          {!isMobile && (
            <button
              type="button"
              className="nizom-sidebar-collapse-button"
              onClick={toggleCollapse}
              aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
              title={collapsed ? "Развернуть" : "Свернуть"}
            >
              <span className={collapsed ? "arrow-right" : "arrow-left"} />
            </button>
          )}
        </div>

        <nav className="nizom-sidebar-nav">
          {filteredMenu.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/"}
              onClick={() => isMobile && setMobileOpen(false)}
              className={({ isActive }) =>
                `nizom-sidebar-link ${isActive ? "active" : ""}`
              }
              title={collapsed && !isMobile ? translations[item.name][lang] : undefined}
            >
              <span className="nizom-sidebar-icon">
                <MenuIcon type={item.icon} />
              </span>

              <span className="nizom-sidebar-link-text">
                {translations[item.name][lang]}
              </span>
            </NavLink>
          ))}
        </nav>

        <div className="nizom-sidebar-bottom">
          <div className="nizom-sidebar-accent" />
          <span>{collapsed && !isMobile ? "N" : "Низоми ягона"}</span>
        </div>
      </aside>
    </>
  );
}
